import React from 'react';
import videojs from 'video.js'
import 'video.js/dist/video-js.css';
import '../assets/css/videojs-style.css';
import './VideoPlayer.css';
import { bindActionCreators } from "redux";
import { setItemView } from "../actions";
import { connect } from "react-redux";
import Logo from "../components/logo/Logo";

class VideoPlayer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showVideo: false,
            showLoading: true,
            hasTranscription: false
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.sources[0].src !== prevProps.sources[0].src) {
            if (this.player) {
                this.player.pause();
                this.player.src(this.props.sources[0].src);
                this.player.load();
                this.player.play();
            }
        }
    }

    componentDidMount() {
        const { item_id, node_id, course_id } = this.props.current_item;
        this.props.onItemView({
            courseID: course_id,
            nodeID: node_id,
            itemID: item_id
        });
        fetch(`/check_transcription/${course_id}/`, {
            credentials: 'include'
        })
            .then(res => res.json())
            .then(flag => this.setState({hasTranscription: flag}))
            .catch(() => this.setState({hasTranscription: false}));
    }

    // destroy player on unmount
    componentWillUnmount() {
        this.removePlayer();
    }

    removePlayer() {
        if (this.player) {
            this.player.dispose()
        }
    }

    initiatePlayer() {
        this.player = videojs(this.videoNode, this.props, function onPlayerReady() {
        });
        this.player.width(800);
        this.player.width(700);
        this.player.fluid(true);
    }


    // wrap the player in a div with a `data-vjs-player` attribute
    // so videojs won't create additional wrapper in the DOM
    // see https://github.com/videojs/video.js/pull/3856
    //   height:700px;
    //     width:100%;
    render() {
        const vid = this.props.sources[0].src;
        let src = `https://player.vimeo.com/video/${vid}`;
        if (!this.state.hasTranscription) {
            src += '&cc=false&transcript=false';
        }
        return (
            <div data-vjs-player
                className="video-player-parent"
            >
                <Logo show={!this.state.showLoading} />
                <iframe
                    src={src}
                    id="video_frame"
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    onLoad={this.checkButton}
                    webkitallowfullscreen
                    mozallowfullscreen
                    allowFullScreen
                    style={{ display: !this.state.showLoading ? 'block' : 'none' }}
                />
            </div>
        )
    }

    checkButton = () => {
        this.setState({ showLoading: false });
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        onItemView: setItemView
    }, dispatch)
}

export default connect(null, mapDispatchToProps)(VideoPlayer);



// WEBPACK FOOTER //
// ./src/containers/VideoPlayer.js